import { useLanguage } from "../lang/LanguageContext";
import profilePic from "../assets/Stirling.jpg"; // add your photo in /src/assets
import { FaGithub, FaEnvelope } from "react-icons/fa";
import { SiHal } from "react-icons/si"; 
import { useState } from "react";
import { parseLinks } from "../utils/parseLinks";

export default function Hero() {
  const { strings } = useLanguage();
  const [showEmail, setShowEmail] = useState(false);
  const textWithLinks = parseLinks(
      strings.project,
      strings.links
    );

  return (
    <section className="flex flex-col md:flex-row items-center justify-center mt-12 px-6 max-w-4xl mx-auto text-white">
      <div className="flex flex-col items-center md:mr-10">
        <img
          src={profilePic}
          alt="Portrait"
          className="w-40 h-40 rounded-full mb-3 object-cover flex-shrink-0 !max-w-none"
        />

        {/* Social Icons */}
        <div className="flex space-x-4 text-2xl text-white">
          {/* Email with popup */}
          <div className="relative">
            <button
              onClick={() => setShowEmail(!showEmail)}
              className="hover:text-blue-700"
            >
              <FaEnvelope />
            </button>
            {showEmail && (
              <div className="absolute left-1/2 -translate-x-1/2 mt-2 px-3 py-2 bg-white border rounded shadow text-sm z-10 text-black w-max">
                {'<'}{strings.buttons.prenom}{'>'}.{'<'}{strings.buttons.nom}{'>'}@lip6.fr
              </div>
            )}
          </div>
          <a href="https://github.com/AMAURYCU" target="_blank" rel="noopener noreferrer">
            <FaGithub className="hover:text-blue-700" />
          </a>
          <a href="https://hal.sorbonne-universite.fr/search/index/q/*/authIdHal_i/1403120" target="_blank" rel="noopener noreferrer">
            <SiHal className="hover:text-blue-700" />
          </a>
        </div>
      </div>
      <div className="mt-6 md:mt-0 md:ml-10 text-white">
        <h1 className="text-3xl font-bold">{strings.name}</h1>
        <p className="text-lg mt-2">{strings.tagline}</p>
   <p className="text-lg mt-2 [&>a]:text-lg [&>a]:mt-2 [&>a]:text-white [&>a]:underline">
  {textWithLinks}
</p>
        <p className="mt-4 text-blue-100">{strings.description}</p>
        <div className="mt-6 space-x-4">
          <a
            href="/assets/cvAC31.pdf"
            target="_blank"
            className="bg-blue-700 text-white px-4 py-2 rounded hover:bg-blue-500"
          >
            {strings.buttons.cv}
          </a>
        </div>
      </div>
    </section>
  );
}
